import graph from './graph';
import PopupHandler from './PopupHandler';
import React, { useEffect, useState } from 'react';
import moment from 'moment';

import { useSelector } from 'react-redux';
import { useLazyQuery } from '@apollo/client';
import { isEmptyObject } from 'helpers/formatObject';
import { digitsFaToEn } from '@persian-tools/persian-tools';

export default function MainModel(props) {
  const { initFilter, isPopup = false } = props;
  const init = {
    max_created_at: digitsFaToEn(moment().format('YYYY-MM-DD')),
    min_created_at: digitsFaToEn(moment().subtract(90, 'days').format('YYYY-MM-DD')),
    status_ids: ['3', '5', '6', '12', '7', '8', '21', '22', '23', '24', '25', '26', '19', '4', '10', '11', '16'],
    ...initFilter,
  };

  const [startFetch, setStartFetch] = useState(!isPopup);
  const [flag, setFlag] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(12);
  const [total, setTotal] = useState(0);
  const [result, setResult] = useState([]);
  const [filter, setFilter] = useState(init);
  const [selectable, setSelectable] = useState(false);
  const { userToken } = useSelector((state) => state.auth);

  const clearFilter = () => setFilter(init);

  const handleSetFilter = (filter) => {
    setPage(1);
    setResult([]);
    setFilter(filter);
  };

  const [getData, { loading }] = useLazyQuery(graph.list.query, {
    context: {
      serviceName: graph.list.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const refresh = () => {
    setPage(1);
    setResult([]);
    setFlag(!flag);
  };

  const handleData = async (paginate) => {
    try {
      const { data, error } = await getData({
        variables: {
          ...filter,
          page,
          limit,
          for_admin: 1,
          min_created_at_equality: '>=',
          max_created_at_equality: '<=',
          call_me: filter?.call_me < 2 ? filter?.call_me : undefined,
          fast_send: filter?.fast_send < 2 ? filter?.fast_send : undefined,
        },
      });
      if (!isEmptyObject(data) && !error) {
        const res = data[graph.list.name];
        setTotal(res?.total);
        paginate ? setResult((prevData) => prevData.concat(res?.data)) : setResult(res?.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    startFetch && handleData(page > 1);
  }, [startFetch, page, filter, flag]);

  useEffect(() => {
    initFilter && setFilter(initFilter);
  }, [initFilter]);

  return (
    <PopupHandler
      {...props}
      page={page}
      limit={limit}
      total={total}
      result={result}
      filter={filter}
      loading={loading}
      refetch={refresh}
      setPage={setPage}
      isPopup={isPopup}
      selectable={selectable}
      clearFilter={clearFilter}
      setFilter={handleSetFilter}
      setStartFetch={setStartFetch}
      setSelectable={setSelectable}
    />
  );
}
